import ComponentsMap from './components-map';

export default ComponentsMap;
